import classNames from "classnames";

export default function AppToggle({
  title,
  onToggle,
  disabled,
  value,
  className,
}: {
  title: string;
  value: boolean;
  onToggle: () => void;
  disabled: boolean;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        "d-flex align-items-center justify-content-between px-2",
        className
      )}
    >
      <h5 className="mb-0">{title}</h5>
      <ToggleInput value={value} onToggle={onToggle} disabled={disabled} />
    </div>
  );
}

function ToggleInput({
  onToggle,
  value,
  disabled,
}: {
  value: boolean;
  onToggle: () => void;
  disabled: boolean;
}) {
  return (
    <div className="d-inline cursor-pointer">
      <label className="custom-toggle">
        <input
          name="default"
          checked={value}
          onChange={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          type="checkbox"
          disabled={disabled}
        />
        <span
          className="custom-toggle-slider rounded-circle"
          data-label-off="No"
          data-label-on="Yes"
        />
      </label>
    </div>
  );
}
